import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const footerLinks = [
  { to: "/", label: "Home" },
  { to: "/portofolio", label: "About Us" },
  { to: "/karir", label: "Work With Us" },
  { to: "/portofolio", label: "FAQs" },
];

const footerProducts = [
  { to: "/layanan", label: "Petugas Keamanan" },
  { to: "/layanan", label: "Pendidikan & Pelatihan" },
  { to: "/layanan", label: "Peralatan (Equipment)" },
  { to: "/layanan", label: "K-9 Unit (K-9 Team)" },
  { to: "/layanan", label: "Monitoring & Controlling" },
];

const linkClass =
  "text-white/70 hover:text-white transition-colors duration-200 inline-block hover:translate-x-0.5 transition-transform";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-brand">
      <div className="container-app py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-white">
          <div className="text-center md:text-left">
            <h6 className="text-lg font-bold mb-5 tracking-wide">Link</h6>
            <ul className="space-y-2.5">
              {footerLinks.map(({ to, label }) => (
                <li key={label}>
                  <HashLink smooth to={to} className={linkClass}>
                    {label}
                  </HashLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Product Section - Tengah */}
          <div className="text-center md:text-left">
            <h6 className="text-lg font-bold mb-5 tracking-wide">Product</h6>
            <ul className="space-y-2.5">
              {footerProducts.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className={linkClass}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section - Kanan */}
          <div className="text-center md:text-left">
            <h6 className="text-lg font-bold mb-5 tracking-wide">PT Berani Setia Waspada</h6>
            <ul className="space-y-2.5 text-white/70">
              <li>Phone: (021)-2955-0215</li>
              <li>Email: beranisetiawaspada@gmail.com</li>
              <li>Ruko De Green R7/7 Mangun Jaya, Tambun Selatan, Kab. Bekasi, Jawa Barat</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="container-app py-5 text-center text-sm text-white/60">
          &copy; {year} PT Berani Setia Waspada. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
